import { createSlice } from "@reduxjs/toolkit";
import { getNationalIdList, getNationalIdCountries, postNationalIdCategory } from "./NationalIdThunk";

const initialState = {
  allNationalId: null,
  allNationalIdErr: null,
  countries: [],
  countriesErr: null,
  newCategory: null,
  newCategoryErr: null,
  newCategorySuccess: false, // Add success state
  loading: false,
};

const NationalIdSlice = createSlice({
  name: "nationalId",
  initialState,
  reducers: {
    resetNewCategory(state) {
      state.newCategory = null;
      state.newCategoryErr = null;
      state.newCategorySuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL NationalId LIST
      .addCase(getNationalIdList.fulfilled, (state, action) => {
        state.allNationalId = action.payload;
        state.allNationalIdErr = null;
        state.loading = false;
      })
      .addCase(getNationalIdList.rejected, (state, action) => {
        state.allNationalIdErr = action.error.message;
        state.loading = false;
      })

      // GET Countries
      .addCase(getNationalIdCountries.fulfilled, (state, action) => {
        state.countries = action.payload.data.countries; // Access the data correctly
        state.countriesErr = null;
        state.loading = false;
      })
      .addCase(getNationalIdCountries.rejected, (state, action) => {
        state.countriesErr = action.error.message;
        state.loading = false;
      })

      // POST new National ID Category
      .addCase(postNationalIdCategory.fulfilled, (state, action) => {
        state.newCategory = action.payload;
        state.newCategoryErr = null;
        state.newCategorySuccess = true;
        state.loading = false;
      })
      .addCase(postNationalIdCategory.rejected, (state, action) => {
        state.newCategoryErr = action.error.message;
        state.newCategorySuccess = false;
        state.loading = false;
      })
      .addCase(postNationalIdCategory.pending, (state) => {
        state.newCategorySuccess = false;
        state.loading = true;
      });
  },
});

export const { resetNewCategory } = NationalIdSlice.actions;
export default NationalIdSlice.reducer;
